var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcStartRecording = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.01 5.75c3.45 0 6.25 2.8 6.25 6.25s-2.8 6.25-6.25 6.25-6.25-2.8-6.25-6.25 2.8-6.25 6.25-6.25"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 1.38c5.85 0 10.62 4.77 10.62 10.62S17.85 22.62 12 22.62C6.14 22.62 1.38 17.85 1.38 12S6.15 1.38 12 1.38m0 1.99c-4.76 0-8.62 3.87-8.62 8.62s3.87 8.62 8.62 8.62 8.62-3.87 8.62-8.62S16.75 3.37 12 3.37",
  clipRule: "evenodd"
})));
export default SvgIcStartRecording;